import { render, staticRenderFns } from "./franchise.vue?vue&type=template&id=147b7e81&scoped=true"
import script from "./franchise.vue?vue&type=script&lang=js"
export * from "./franchise.vue?vue&type=script&lang=js"
import style0 from "./franchise.vue?vue&type=style&index=0&id=147b7e81&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147b7e81",
  null
  
)

export default component.exports